// UI strings for Apufraasit, the conversation lifelines (together/lifelines/; Axel's decision of
// 2026-10-09): the row on Puhutaan (/shared/speak) and the help of the ladder's step 3. The lines'
// own Finnish lives with them (lifelines.ts). Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const lifelinesFi = {
  title: 'Apufraasit',
  /** Step 3, under the answer card: what to say when the question did not land. */
  stepHelp: 'Jos et ymmärrä, sano se valyriaksi:',
  /** A line of ours built from Peterson's sentences (as the lessons' <Practice>). */
  ours: 'harjoituslause',
};

export const lifelinesEn: typeof lifelinesFi = {
  title: 'Lifelines',
  stepHelp: 'If you did not understand, say so in Valyrian:',
  ours: 'practice sentence',
};

export const area = defineArea('lifelines', lifelinesFi, lifelinesEn);

declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof lifelinesFi> {}
}
